import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import CssBaseline from "@mui/material/CssBaseline";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import SettingsContext from "./settingsContext";
import useClasses from "../useClasses";

const styles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
});

export default function Profile(props) {
  const classes = useClasses(styles);
  const { t } = useTranslation();
  const { settings, handleChange } = useContext(SettingsContext);
  return (
    <div>
      <Container
        component="main"
        maxWidth={props.maxWidth}
        onSubmit={(e) => e.preventDefault()}
      >
        <CssBaseline />
        <div className={classes.paper}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">{t("account.noti.subtitle")}</Typography>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Boolean(settings.mailOnAdded)}
                    onChange={handleChange}
                    name={"mailOnAdded"}
                    color="primary"
                  />
                }
                label={t("account.noti.mailOnAdded")}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Boolean(settings.mailOnNews)}
                    onChange={handleChange}
                    name={"mailOnNews"}
                    color="primary"
                  />
                }
                label={t("account.noti.mailOnNews")}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Boolean(settings.mailOnResearch)}
                    onChange={handleChange}
                    name={"mailOnResearch"}
                    color="primary"
                  />
                }
                label={t("account.noti.mailOnResearch")}
              />
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
}
